import "./Styles/listing-channels.scss";

import config from "../../app.json";
import axios from "axios";
import Pagination from "../../Components/Pagination/pagination";

import { Context } from "../../Reducers/Store";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button } from "react-bootstrap";
import AlertComponent from "../../Components/AlertComponent";
import SeriesCard from "../../Components/SeriesCard/series-card";

function ListingSeries() {
  const [state, dispatch] = useContext(Context);
  let navigate = useNavigate();
  const [cards, setCards] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [generalSeries, setGeneralSeries] = useState(null);
  const itemsPerPage = 8;

  const isAdmin = state.profile?.role == "ROLE_CHURCH_ADMIN";

  const fetchGeneralSeries = () => {
    axios
      .post(config.API + "/api/series/getGeneralSeries")
      .then((res) => {
        if (res.status === 200 && res.data) {
          setGeneralSeries(res.data);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  const fetchSeries = () => {
    axios
      .post(config.API + "/api/series/getSeriesList", {
        page: currentPage,
        perPage: itemsPerPage,
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          if (res.data.values.$values.length) {
            setTotalItems(res.data.total);
          } else {
            setTotalItems(0);
          }

          setCards(res.data.values.$values);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  useEffect(() => {
    const totalPagesCalculated = Math.ceil(totalItems / itemsPerPage);
    setTotalPages(totalPagesCalculated);
  }, [totalItems]);

  useEffect(() => {
    fetchSeries();
  }, [currentPage]);

  useEffect(() => {
    fetchGeneralSeries();
  }, [0]);

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const paginationElement = cards && cards.length ? (
    <div className="pagination-container">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onNextPage={nextPage}
        onPrevPage={prevPage}
      />
    </div>
  ) : null;

  return (
    <Row>
      <Col className="col-md-11">
        {isAdmin && (
          <Row className="listing-channels-container">
            <Col className="col-md-12">
              <Button
                onClick={() => navigate("/videoArchive/series/new", { replace: false })}
                className="add-new-btn mt-4 mb-4"
              >
                Add new
              </Button>
            </Col>
          </Row>
        )}
        <Row>
          {currentPage === 0 && generalSeries && (
            <Col className="col-md-3 mb-4">
              <SeriesCard
                name={generalSeries.name}
                coverGuid={generalSeries.coverGuid}
                videoCount={generalSeries.videoCount}
                canManage={isAdmin}
                isGeneral={true}
              />
            </Col>
          )}
          {cards?.map((x, index) => (
            <Col className="col-md-3 mb-4">
              <SeriesCard
                {...x}
                index={index}
                canManage={isAdmin}
                onDelete={fetchSeries}
              />
            </Col>
          ))}
          {(!cards || !cards.length) && !generalSeries && <Col className="col-md-6"><div className="empty-state-card" >There are no registered series</div></Col>}

          {paginationElement}
        </Row>
      </Col>
    </Row>
  );
}

export default ListingSeries;
